
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/modern/components/ui/dropdown-menu";
import { cn } from "@/modern/utils";
import { MoreVertical } from "lucide-react";
import { useState } from "react";
import { useEntityManagerContext } from "../context/EntityManagerContext";

export const EntityMoreMenu = () => {
  const { entityConfig, activeTab, setActiveTab } = useEntityManagerContext();
  const [open, setOpen] = useState(false);
  if (entityConfig.tabs.length <= 1) return null;
  return (
    <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger className="bg-transparent">
        <MoreVertical className="size-5 bg-background" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-background">
        {entityConfig.tabs.map((tab, index) => (
          <DropdownMenuItem key={index} onClick={() => setActiveTab(String(index))} className={cn(activeTab === String(index) && "!bg-sidebar-primary !text-sidebar-primary-foreground")}>
            {tab.icon && <i className={`${tab.icon} mr-2 h-4 w-4`} />}
            {tab.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
